import axios from 'axios';
import firebase from '../firebase';

const api = axios.create({
  baseURL: '/api'
});

const waitForAuthInit = () => new Promise((resolve) => {
  const auth = firebase.auth();
  if (auth.currentUser) {
    resolve(auth.currentUser);
    return;
  }

  const unsubscribe = auth.onAuthStateChanged((user) => {
    unsubscribe();
    resolve(user || null);
  });
});

// 🔐 Request interceptor (runs before EVERY request)
api.interceptors.request.use(
  async (config) => {
    let user = firebase.auth().currentUser;
    if (!user) {
      user = await waitForAuthInit();
    }

    if (user) {
      const token = await user.getIdToken();
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

export default api;
